/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IColumn } from 'types'
import MainTableActionButtons from 'components/organisms/MainTableActionButtons'
import { Button, Tooltip, Box, useTheme } from '@mui/material'

export const useTableModel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();

  const handleActionsFormat = useCallback(
    (cellValue: string, row: any, index: number) => <MainTableActionButtons 
      baseUrl={'/rti-risks/'} params={row?.sid ? [{k: 'student_id', v: row.sid}] : []} row={row} />,
    [],
  )

  const handleNameFormat = useCallback((cellValue: string, row: any) => {
    return <Box onClick={ () => navigate(`/rti-students/${row.student_id}#criteria`) } sx={{ cursor: 'pointer', '&:hover': {
      color: 'red'
    } }}>{cellValue}<br/>{row.student_academic_id && "#"+row.student_academic_id}</Box>
  }, [])

  const handleProblemAreasFormat = useCallback(
    (cellValue: string, row: any, index: number) => row.problem_areas?.map(a => a.title).join(', '),
    [],
  )
  const handleParentDiscussionFormat = useCallback(
    (cellValue: string, row: any, index: number) => row?.parent_dicussion,
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('common.groups')}`,
      field: 'student_groups',
      order: false,
      width: '10%',
    },
    {
      title: `${t('common.student')}`,
      field: 'student_name',
      order: false,
      width: '20%',
      format: handleNameFormat,
    },
    {
      title: `${t('common.comment')}`,
      field: 'comment',
      order: false,
      width: '30%',
    },
    {
      title: `${t('common.problem-areas')}`,
      field: 'problem_areas',
      order: false,
      width: '30%',
      format: handleProblemAreasFormat,
    },
    {
      title: '',
      field: '',
      width: '10%',
      align: 'end',
      order: false,

      format: handleActionsFormat,
    },
  ]

  return columns
}
